import { Link, useRouteMatch } from "react-router-dom";

import { Box, Logo as SenekitLogo, useBreakpoint } from "@seneca/senekit";

import { linkToAnonymousCourseDiscoveryWithDefaultFilters } from "features/anonymous-pages/course-discovery/links";
import Logo from "features/common/logos/Logo";
import ParentLogo from "features/common/logos/ParentLogo";
import { useIsPlurallApp } from "features/plurall";

import { linkToSignUpParent } from "../links";
import styles from "./LogoPageWrapper.module.scss";

export default function LogoComponent() {
  const isPlurallApp = useIsPlurallApp();

  const urlMatchesSignUpParent = useRouteMatch(linkToSignUpParent());
  const urlMatchesSignUpParentExactly = urlMatchesSignUpParent?.isExact;

  const { isMobileOnly } = useBreakpoint();

  if (isPlurallApp)
    return (
      <Logo className={styles.logo} width="auto" height={["30px", "40px"]} />
    );

  if (urlMatchesSignUpParentExactly) {
    return (
      <Link to={linkToAnonymousCourseDiscoveryWithDefaultFilters()}>
        <Box
          position="absolute"
          top="20px"
          width={["128px", "176px"]}
          marginX={["large", "xlarge"]}
        >
          {isMobileOnly ? (
            <SenekitLogo variant="goStudent" height={["30px", "40px"]} />
          ) : (
            <ParentLogo />
          )}
        </Box>
      </Link>
    );
  }
  return (
    <Link to={linkToAnonymousCourseDiscoveryWithDefaultFilters()}>
      <Logo className={styles.logo} width="auto" height={["30px", "40px"]} />
    </Link>
  );
}
